/** Only same-site paths, so a crafted ?next= link cannot send people elsewhere after sign-in. */
export const safeNext = (next: string | null): string =>
  next?.startsWith('/') && !next.startsWith('//') && !next.startsWith('/\\') ? next : '/';
